<app-spinner></app-spinner>
<div class="container-fluid">
  <div class="row mt-2">
    <div class="col-12">
      <h4 style="font-weight:bold;">{{ translation.t('operatorComplaint','totalComplaints') }}</h4>
    </div>

  </div>

  <div class="row mt-4">
    <div class="col-12 d-flex justify-content-end gap-2 add-Complaint flex-wrap">
      <button class="hover-light flex-grow-1 flex-md-grow-0" style="background-color: #226CE0; color: white; min-width: fit-content;" mat-raised-button
        routerLink="/sdp/operator/new-compliants"><i class="fa fa-plus"></i> <span> &nbsp;{{ translation.t('operatorComplaint','addNewComplaints') }}
          </span></button>
      <button style="background-color: #1D6F42; color: white; min-width: fit-content;" mat-raised-button
        class="flex-grow-1 flex-md-grow-0"
        (click)="exportToExcel()"><i class="fa fa-file-excel-o"></i> <span> &nbsp;{{ translation.t('operatorComplaint','export') }}</span></button>
      <button style="background-color: #f44336; color: white; min-width: fit-content;" mat-raised-button
        class="flex-grow-1 flex-md-grow-0"
        (click)="exportToPDF()"><i class="fa fa-file-pdf-o"></i> <span> &nbsp;{{ translation.t('common','pdf') }}</span></button>
    </div>
  </div>

  <div class="row mt-2 align-items-center">
    <div class="col-12 d-flex flex-wrap gap-2 align-items-center">
      
      <div class="d-flex flex-wrap gap-2 flex-grow-1 align-items-end">
        <div class="flex-grow-1" style="min-width: 200px;">
          <label style="font-size: 13px; font-weight: 500; margin-bottom: 4px;">{{ translation.t('operatorComplaint','searchPlaceholder') }}</label>
          <input type="text" class="form-control fontAwesome w-100" style="padding: 8px;" [(ngModel)]="searchText"
            [placeholder]="translation.t('operatorComplaint','searchPlaceholder')">
        </div>

        <div class="flex-grow-1" style="min-width: 200px;">
          <label style="font-size: 13px; font-weight: 500; margin-bottom: 4px;">{{ translation.t('common','fromDate') }}</label>
          <input type="date" class="form-control w-100" style="padding: 8px;" [(ngModel)]="fromDate" [max]="toDate">
        </div>

        <div class="flex-grow-1" style="min-width: 200px;">
          <label style="font-size: 13px; font-weight: 500; margin-bottom: 4px;">{{ translation.t('common','toDate') }}</label>
          <input type="date" class="form-control w-100" style="padding: 8px;" [(ngModel)]="toDate" [min]="fromDate">
        </div>

        <div class="flex-grow-1" style="min-width: 200px;">
          <label style="font-size: 13px; font-weight: 500; margin-bottom: 4px;">{{ translation.t('operatorComplaint', 'zone') || 'Zone' }}</label>
          <ng-select
            [(ngModel)]="selectedZone"
            [items]="uniqueZones"
            [placeholder]="translation.t('adminDashboard', 'allZones')"
            [clearable]="true"
            [searchable]="true">
          </ng-select>
        </div>

        <div class="flex-grow-1" style="min-width: 200px;">
          <label style="font-size: 13px; font-weight: 500; margin-bottom: 4px;">{{ translation.t('operatorComplaint', 'department') || 'Department' }}</label>
          <ng-select
            [(ngModel)]="selectedDept"
            [items]="uniqueDepartments"
            [placeholder]="translation.t('adminDashboard', 'selectDepartment')"
            [clearable]="true"
            [searchable]="true">
          </ng-select>
        </div>

        <div class="flex-grow-0 d-flex gap-2">
          <button style="background-color: #226CE0; color: white; padding: 6px 16px; border: none; border-radius: 4px; display: flex; align-items: center; gap: 8px; height: 38px;" 
            (click)="applyFilters()">
            <i class="fa fa-search"></i> {{ translation.t('common','search') }}
          </button>
          <button style="background-color: #6c757d; color: white; padding: 6px 16px; border: none; border-radius: 4px; display: flex; align-items: center; gap: 8px; height: 38px;" 
            (click)="clearFilters()">
            <i class="fa fa-times"></i> {{ translation.t('common','clear') }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">

      <div class="table-responsive">
        <table class="table table-bordered w-100 tableshadow">
          <thead class="table table-light">
            <tr>
              <th class="text-center">{{ translation.t('operatorComplaint','srNo') }}</th>
              <th class="text-center">{{ translation.t('operatorComplaint','ticketId') }}</th>
              <th class="text-center">{{ translation.t('operatorComplaint','department') }}</th>
              <th class="text-center">{{ translation.t('operatorComplaint','zone') }}</th>
              <th class="text-center">{{ translation.t('operatorComplaint','fullName') }}</th>
              <th class="text-center">{{ translation.t('operatorComplaint','mobileNo') }}</th>
              <th class="text-center">{{ translation.t('operatorComplaint','createDate') }}</th>
              <th class="text-center">{{ translation.t('operatorComplaint','daysOpen') }}</th>
              <th class="text-center">{{ translation.t('operatorComplaint','status') }}</th>
              <th class="text-center">{{ translation.t('operatorComplaint','action') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let  obj of showComplaints; let i=index">
              <td class="text-center">{{ (currentPage - 1) * pageSize + i + 1 }}</td>
              <td class="text-center">{{ obj.ticket_id }}</td>
              <td class="text-center">{{ obj.departments }}</td>
              <td class="text-center">{{ obj.zone }}</td>
              <td class="text-center">{{ obj.full_name }}</td>
              <td class="text-center">{{ obj.mobile_no }}</td>
              <td class="text-center">{{ obj.create_date }}</td>
              <td class="text-center">{{ obj.number_of_open_days }}</td>
              <td class="text-center">{{ obj.status }}</td>

              <td class="text-center"
                style="position: relative;  align-items: center; justify-content: center;gap: 10px;">
                <div style="justify-content: center;display: flex;align-items: center;gap: 10px;">
                  <span class="view"
                    style="color: rgb(0, 26, 255); text-decoration: underline; cursor: pointer; margin: 5px 0;"
                    (click)="route(obj)" [title]="translation.t('operatorComplaint','viewDetailedInfo')">
                    <strong>{{ translation.t('operatorComplaint','viewMore') }}</strong>
                  </span>


                  <span class="more-dots" (click)="togglePrintOption(obj)"
                    style="cursor: pointer; font-size: 20px; color: rgb(0, 26, 255); user-select: none;">
                    <strong>&#8942;</strong>
                  </span>

                </div>
                <div *ngIf="activeRow === obj" class="tooltip-print"
                  style="position: absolute; top: 30px; right: 0; background: whitesmoke; color: rgb(1, 159, 244); text-decoration: underline;font-size: 14px; padding: 15px; cursor: pointer;  box-shadow: -1px 1px 4px 0px rgba(136, 132, 161, 0.25), 1px -1px 4px 0px rgba(136, 132, 161, 0.25), -1px -1px 4px 0px rgba(136, 132, 161, 0.25), 1px 1px 4px 0px rgba(136, 132, 161, 0.25); z-index: 1;"
                  (click)="onDownloadPDF(obj); closePrintOption()" [title]="translation.t('operatorComplaint','printFormTitle')">
                  {{ translation.t('operatorComplaint','printForm') }}
                </div>
              </td>


              <!-- style="border-radius: 6px;" -->
              <!-- [ngStyle]="{'color': obj.status === 'Active' ? '#226CE0' : '#226CE0', 'color': 'white' }" -->
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-end align-items-end me-2 mt-3 flex-wrap">
        <span style="color: #6D6D6D; font-size: 14px;">
          {{ translation.t('operatorComplaint','showing') }} {{ complaints.length }} {{ translation.t('operatorComplaint','of') }} {{ allComplaints.length }} {{ translation.t('operatorComplaint','departments') }}
        </span>

        <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
          <label class="me-1">{{ translation.t('operatorComplaint','perPage') }}</label>
          <select [(ngModel)]="pageSize" (change)="changePageSize()" class="form-select form-select-sm w-auto">
            <option *ngFor="let size of page_list" [value]="size">{{ size }}</option>
          </select>

          <button class="btn-sm fw-bold px-3 py-1 me-2" (click)="prevPage()"
            [disabled]="currentPage === 1">&lt;</button>

          <span style="font-weight: 600;">{{ currentPage }} / {{ totalPages }}</span>

          <button class="btn-sm fw-bold px-3 py-1" (click)="nextPage()"
            [disabled]="currentPage === totalPages">&gt;</button>
        </div>
      </div>
      <!-- <div class="shadow-wrapper"> 
                <table mat-table  [dataSource]="complaints" class="mat-elevation-z8" style="width: 100%;">

                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>ID</th>
                        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                    </ng-container>
 
                    <ng-container matColumnDef="dept">
                        <th mat-header-cell *matHeaderCellDef>Department</th>
                        <td mat-cell *matCellDef="let element">{{ element.dept }}</td>
                    </ng-container>

                  
                    <ng-container matColumnDef="zone">
                        <th mat-header-cell *matHeaderCellDef>Zone</th>
                        <td mat-cell *matCellDef="let element">{{ element.zone }}</td>
                    </ng-container>

                    
                    <ng-container matColumnDef="ward">
                        <th mat-header-cell *matHeaderCellDef>Ward</th>
                        <td mat-cell *matCellDef="let element">{{ element.ward }}</td>
                    </ng-container>

                    
                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef>Create date</th>
                        <td mat-cell *matCellDef="let element" class="created">{{ element.create_date }}</td>
                    </ng-container>

                   
                    <ng-container matColumnDef="days_Open">
                        <th mat-header-cell *matHeaderCellDef>Days Open</th>
                        <td mat-cell *matCellDef="let element" class="center1">{{ element.number_of_open_days }}</td>
                    </ng-container>
                    
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                </table>
            </div> -->
    </div>
  </div>
</div>
